var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _polyline, _polyline2, _polygon, _path15, _path16, _path17, _ellipse, _ellipse2, _ellipse3, _line, _line2, _line3, _line4, _line5, _path18, _polyline3, _polyline4, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _polygon2, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _ellipse4, _path36, _path37, _path38, _ellipse5, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 300",
    width: 406,
    height: 306,
    className: "illustration styles_illustrationTablet__1DWOa",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 311.03,
    y1: 208.3,
    x2: 332.41,
    y2: 188.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e75d48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#502019"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 137.47,
    y1: 235.44,
    x2: 163.23,
    y2: 211.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 44.8,
    y1: 187.6,
    x2: 68.37,
    y2: 168.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 189.93,
    y1: 210.01,
    x2: 218.27,
    y2: 172.22,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PP") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.51,291.25,22,189.3c-5.49-3.08-10.2-8.15-4.85-11.46L190.29,78.06c2.6-1.61,6.54-2.66,9.18-1.13L380.54,182c5.49,3.19,6.48,12.1,1,15.29L217.25,291.09A22.94,22.94,0,0,1,194.51,291.25Z",
    fill: "#e75d48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.29,182.6c-13.16,7.67-22.56,12.83-42.8,24.38,15.32,9.31,28.71,16.14,30.43,17.16l44-25C350.35,197.31,338.67,190.7,322.29,182.6Z",
    opacity: 0.32,
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151,204.47c-15.86,9.25-27.19,15.46-51.58,29.38,18.46,11.22,34.6,19.46,36.68,20.68l53-30.09C184.85,222.2,170.78,214.23,151,204.47Z",
    opacity: 0.32,
    fill: "url(#linear-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.27,193.95c8.23-5.48,16.6-10.76,24.92-16.09l-11.82-8.63L21.59,188.33c5.53,2.9,13,8.33,20.86,13.86C46.36,199.4,50.27,196.61,54.27,193.95Z",
    opacity: 0.32,
    fill: "url(#linear-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.68,147.26a2.1,2.1,0,0,0-.37-.78,4.67,4.67,0,0,0-1.14-1c-5.81-3.93-13.86-5-20-1.17-1.4.88-3.49,2.87-2.66,4.75.48,1.09,1.94,1.73,3,2.17A44.57,44.57,0,0,0,73,154c1.3.22,2.62.44,3.93.56a5.43,5.43,0,0,0,4.79-2.05C82.63,151.32,84.09,149,83.68,147.26Z",
    fill: "#754c24"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.34,148.2s5.3,4.8,14.46,4.1,9.87-5,9.87-5-2.37,30.36-3.62,30.88-5.93,2.78-8.19,2.95-9.4-2.69-9.58-3.48S59.34,148.2,59.34,148.2Z",
    fill: "#ff8f6f"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61,104c-.28-.57-1.15-.07-.86.5,6.27,12.64,7.49,26.87,8.62,40.69.05.63,1.05.64,1,0C68.63,131.14,67.37,116.76,61,104Z",
    fill: "#007f68"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.21,104.08s1.75,6.56-.06,9.84-3.3,3.93-1.14,8,7.94,4.62,8.32,7.74S64.57,109.65,60.21,104.08Z",
    fill: "#007f68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.26,115.92a82.45,82.45,0,0,0-8,32.26c0,.78,1.19.77,1.22,0a81,81,0,0,1,7.79-31.66C81.65,115.83,80.6,115.21,80.26,115.92Z",
    fill: "#007f68"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M81.12,119.11c0-.66-.15-2-.08-3.11l-.7.44c-2.38,5.79-5.94,19.39-7,23.55,1.45-3.12,7.38-3.55,9.12-8a8.19,8.19,0,0,0,.1-5.91A21.82,21.82,0,0,1,81.12,119.11Z",
    fill: "#007f68"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M214.59,232.12c16.12-8.68,54.27-27.87,70.27-36.75l-92.08-57.61-66.44,45.11C143.2,191.69,191.26,217.69,214.59,232.12Z",
    opacity: 0.32,
    fill: "url(#linear-gradient-4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136.88,135c.07,21.33.19,40.53.19,40.53s.45,1.74,3.66.32V133.72C139.45,134.15,138.17,134.56,136.88,135Z",
    fill: "#5b434d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M226.07,186.84c.07,21.33.19,40.53.19,40.53s.45,1.74,3.66.32V185.6C228.64,186,227.36,186.44,226.07,186.84Z",
    fill: "#5b434d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M281,154.52c.07,21.33.19,40.53.19,40.53s.45,1.74,3.66.32V153.28C283.58,153.7,282.3,154.12,281,154.52Z",
    fill: "#5b434d"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "136.13 133.72 136.13 137.35 228.17 190.6 284.77 153.43 284.86 149.37",
    fill: "#a5dd73"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "136.13 133.72 136.13 137.35 228.17 190.6 284.77 153.43 284.86 149.37",
    fill: "#6db720",
    opacity: 0.76
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "136.13 133.72 195.35 99.94 284.86 149.37 227.85 186.96 136.13 133.72",
    fill: "#a5dd73"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M218.31,116.14l-12.47,6a2.87,2.87,0,0,0-.2,5.07l29.57,17.25a2.87,2.87,0,0,0,3.86-.93l7.18-11.17",
    fill: "#56403d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M281,84.17,179.13,25.5a3.31,3.31,0,0,0-5,2.87V90.7a2.56,2.56,0,0,0,1.28,2.21l108.39,62.57a1.23,1.23,0,0,0,1.85-1.07V92.33A9.42,9.42,0,0,0,281,84.17Z",
    fill: "#68e1fd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.9,31l96.46,55.5a6.76,6.76,0,0,1,3.39,5.86v44.7a2.44,2.44,0,0,1-3.66,2.12L178.72,82.74a2.41,2.41,0,0,1-1.21-2.09V33A2.27,2.27,0,0,1,180.9,31Z",
    fill: "#200a52"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 222.52,
    cy: 115.11,
    rx: 1.05,
    ry: 0.01,
    transform: "translate(-17.76 44.17) rotate(-10.9)",
    fill: "#ab643c"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.43,
    cy: 87.89,
    rx: 1.05,
    ry: 1.14,
    fill: "#659fe4"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 270.08,
    cy: 86.22,
    rx: 1.05,
    ry: 1.14,
    fill: "#c5e9ff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 182.92,
    y1: 43.35,
    x2: 242.07,
    y2: 76.96,
    fill: "none",
    stroke: "#00a99d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 183.13,
    y1: 52.14,
    x2: 192.71,
    y2: 57.58,
    fill: "none",
    stroke: "#d4145a",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 195.54,
    y1: 59.42,
    x2: 248.78,
    y2: 88.69,
    fill: "none",
    stroke: "#29abe2",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 182.92,
    y1: 60.16,
    x2: 203.36,
    y2: 71.43,
    fill: "none",
    stroke: "#f7931e",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 206.75,
    y1: 73.57,
    x2: 251.58,
    y2: 97.55,
    fill: "none",
    stroke: "#00a99d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M316.58,80.64v43a4.79,4.79,0,0,1-7.25,4.12l-40.91-24.4a4.79,4.79,0,0,1-2.34-4.12V57a4.79,4.79,0,0,1,7.19-4.15l40.91,23.62A4.79,4.79,0,0,1,316.58,80.64Z",
    fill: "#a5dd73"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "287.38 75.78 274.12 85.53 286.01 102.22",
    fill: "none",
    stroke: "#006837",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "299.11 82.82 308.87 101.88 295.15 108.28",
    fill: "none",
    stroke: "#006837",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M183.77,122.22,162.28,134.5a1.48,1.48,0,0,0,0,2.56L222,171.39a4.77,4.77,0,0,0,4.76,0l20.11-11.61a1.54,1.54,0,0,0,0-2.67l-60.4-34.89A2.67,2.67,0,0,0,183.77,122.22Z",
    fill: "#200a52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M216.24,141.8l-6.13,3.64,4.55,2.64,6.16-3.62Z",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M209.52,137.89l-6.13,3.64,5.77,3.35,6.16-3.62Z",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.1,123.71l-6.23,3.58,5.54,3.22,6.16-3.62Z",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M198.23,131.34,192.1,135l4.55,2.64,6.16-3.62Z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M191.51,127.43l-6.13,3.64,5.76,3.35c.68-.39,4.54-2.67,6.16-3.62Z",
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M221.75,145l-6.13,3.64,4.36,2.53,6.15-3.62Z",
    fill: "#fff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M203.74,134.54l-6.13,3.64,4.82,2.8,6.16-3.62Z",
    fill: "#fff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M227.07,148.08l-6.13,3.64,5.77,3.35,6.16-3.62Z",
    fill: "#fff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "233.79 151.99 227.65 155.62 238 161.63 244.23 158.05 233.79 151.99",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M178.08,128.35l-6.23,3.58,8.06,4.68,6.16-3.62Z",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M193.72,137.43l-6.13,3.64,4.55,2.64,6.16-3.62Z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M205,144l-6.13,3.64,5.77,3.35,6.16-3.62Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M199.23,140.63l-6.13,3.64,4.82,2.8,6.16-3.62Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M211.73,147.89l-6.13,3.64,4.55,2.64,6.15-3.62Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217.24,151.09l-6.13,3.64,4.36,2.53,6.15-3.62Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M187,133.53l-6.13,3.64,5.76,3.35,6.16-3.62Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M222.55,154.18l-6.13,3.64,5.77,3.35,6.15-3.62Z",
    fill: "#fff"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "223.14 161.72 230.97 166.27 237.21 162.69 229.27 158.08 223.14 161.72",
    fill: "#fff"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "218.55 161.09 213.99 163.81 219.28 166.87 223.91 164.21 218.55 161.09",
    fill: "#fff"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "220.38 167.51 224.88 170.11 229.52 167.46 224.93 164.8 220.38 167.51",
    fill: "#fff"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "170.39 133.12 165.61 135.78 171.03 138.91 175.72 136.22 170.39 133.12",
    fill: "#fff"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "176.73 136.81 172.12 139.55 177.91 142.9 182.59 140.21 176.73 136.81",
    fill: "#fff"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "183.61 140.8 179.01 143.54 212.89 163.17 217.53 160.5 183.61 140.8",
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.69,
    cy: 192.74,
    rx: 18.83,
    ry: 9.31,
    fill: "#68e1fd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M358.53,167.94v25.32s-14,13-37.67.21V167.94",
    fill: "#68e1fd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M343.83,192.49c-5.2,4-11.48,5.9-17.92,6.58a30.14,30.14,0,0,0,13.78,3c10,0,18.17-3.86,18.77-8.74l.06-.05V167.94h-.35C355,177,351.66,186.41,343.83,192.49Z",
    fill: "#200a52",
    opacity: 0.21
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M323.68,177s-3.12-4.77-6.06-2-.37,12.3,8.26,13.22V192s-10.83-1.47-12.3-11.2,5.51-11.23,9-8.55",
    fill: "#68e1fd"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 339.69,
    cy: 168.04,
    rx: 18.83,
    ry: 9.31,
    fill: "#663535"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M162.47,168c-4.64-3.24-10.1-5-16-3.72-6.28,1.38-11.72,5.33-18.12,6.3-1,.15-5.05-.11-5.67.48-17.81,16.86,32,15.05,32,15.05,4.83-4,9.38-7.85,14.18-11.85C167.4,171.06,165,169.78,162.47,168Z",
    fill: "#f8997c"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M139,192.48l-1.77,50.86c-.07,1.93,2.93,1.93,3,0L142,192.48C142.1,190.55,139.11,190.56,139,192.48Z",
    fill: "#f8997c"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M176.37,219.69q-13.6-13.31-26-27.78c-1.26-1.47-3.37.66-2.12,2.12q12.38,14.46,26,27.78C175.63,223.16,177.76,221,176.37,219.69Z",
    fill: "#f8997c"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M128.64,187.78q-10.56,19.93-19.89,40.47c-.79,1.74,1.79,3.27,2.59,1.51q9.33-20.54,19.89-40.47C132.13,187.59,129.55,186.07,128.64,187.78Z",
    fill: "#f8997c"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M163.71,134c.61-.15,5.74-1.47,7-1.89s5.16-3.45,7.28-3,6.39,3.26,6.59,4.2-1,2.08-1.45,2.49-3.54-.72-4.74-.91-3.11,2.65-4.24,3.15-8.43,1.81-8.43,1.81",
    fill: "#fcbf81"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M177.5,146.46c.61-.15,5.74-1.47,7-1.89s5.16-3.45,7.28-3,6.39,3.26,6.59,4.2-1,2.08-1.45,2.49-3.54-.72-4.74-.91-3.11,2.65-4.24,3.15-8.43,1.81-8.43,1.81",
    fill: "#fcbf81"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M175.51,211.09c.93-1,1.54-2,1.22-3.05-.57-1.87-3.11-2.63-4.85-2.53s-3.54,1-5.3,1.5a13.17,13.17,0,0,1-5.75.71,1.28,1.28,0,0,1-.8-.45,3.17,3.17,0,0,1-2.33-2.12l-5.76-2.06s-1.47,12.17-1.42,13c.43,6.57,10.24,2.82,10.24,2.82s.35-3,.44-3.37,3.85.77,5.4.53a6.8,6.8,0,0,0,2-.93c1.16-.64,2.3-1.32,3.43-2S174.34,211.79,175.51,211.09Z",
    fill: "#56403d"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M154,166.17c-2.16.21-4.32.49-6.47.8q1.34,20.73,3,41.43c5.6,2.29,7.87,1.23,11.34-2.32.66-13.17,1.81-27,1.78-40.28C160.45,165.94,157.23,166.08,154,166.17Z",
    fill: "#34323d"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M130.73,162.38s-.93,15.13,6.67,18.5,23.19,1.69,30.86-2.81a82.82,82.82,0,0,1,12.44-6.21s2-6.62-2.81-9.48-15.35-6.4-24.73,0",
    fill: "#34323d"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M169.48,139.73c.81-3.09.34-8.19.34-8.19s-9.49,1.62-13.49,1-10.54-9-10.54-9l.89,16.6C154.26,141.73,162.11,142.07,169.48,139.73Z",
    fill: "#ba3e00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M193.06,220.57c.93-1,1.54-2,1.22-3.05-.57-1.87-3.11-2.63-4.85-2.53s-3.54,1-5.3,1.5a13.17,13.17,0,0,1-5.75.71,1.28,1.28,0,0,1-.8-.45,3.17,3.17,0,0,1-2.33-2.12l-5.76-2.06s-1.47,12.17-1.42,13c.43,6.57,10.24,2.82,10.24,2.82s.35-3,.44-3.37,3.85.77,5.4.53a6.8,6.8,0,0,0,2-.93c1.16-.64,2.3-1.32,3.43-2S191.9,221.27,193.06,220.57Z",
    fill: "#56403d"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M170.9,162.75c-2-.94-4.06-.84-6.44-.83.33,4.87.15,6.62.45,11.48l.08,1.29c.92,14.4,2,28.79,3.1,43.18,5.6,2.29,7.87,1.23,11.34-2.32.77-15.33,2.22-31.51,1.66-46.77C177.86,165.58,175,164.67,170.9,162.75Z",
    fill: "#34323d"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6,159.25c0,.37.07,1.62.13,3.13,3.15,4.15,7,6.58,13,6.4,4.89-.14,9-2.28,12.8-4.92-.48-8.85-1.91-24-4.14-34.53-.19-.89-2.5-1.49-3.18-1.86-1.59-.87-.66-2.37-2.22-3.3a53.5,53.5,0,0,0-7.05-3.44h-.06c-3.89-.06-10.6,2.94-11,8.15-.61,8,.27,12.85.89,20.84C130,152.94,130.33,156.12,130.6,159.25Z",
    fill: "#e55600"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M144.15,105.56c.51.13,4.83,10.07,3.14,16.11s-11.95-.17-14.53-4.77S134.45,103,144.15,105.56Z",
    fill: "#fcbf81"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M144,106.95s0,3.28-2.87,4.34-5.26,1.77-5.1,3.1,5.19-.19,5.21,2.85a22.66,22.66,0,0,1-.82,6.06c-.32,1.49-8.93-3.08-11.77-10.86s4.27-9.85,4.62-9.9,1-2.17,4.47-2.93,4.47.6,4.47.6a4.23,4.23,0,0,1,5.09.55c3.21,2.55,2.4,7.21-1.24,9.1Z",
    fill: "#34323d"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M183.6,144c-4.47.93-13.55,2.41-16.76,1-2.49-1.09-10.8-18.91-19.83-20.82l-1.22,13.6s12.77,16.2,18.67,17.87c4.29,1.21,15.84-.41,20.91-2.17A19.35,19.35,0,0,0,183.6,144Z",
    fill: "#e55600"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M155.31,148.19c-.65-.84-8.05-9.22-8.05-9.22l8.89,18.21Z",
    fill: "#34323d"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M168.16,174a22.48,22.48,0,0,1-11.24,8.25c-6.34,1.93-15.56,1-18.89-5.61-6.06-12.06-.37-27.16-6.77-38.89a11.76,11.76,0,0,0-7.43-6.1c-4.15-.91-7,2.21-8.5,5.88-2.7,6.58-2.6,14.77-2.47,21.78a118.92,118.92,0,0,0,1.23,16.92s3.88,23.51,34.12,17.2a45.47,45.47,0,0,0,14.86-5.5,20.48,20.48,0,0,0,6.06-5.33C171,179.88,169.75,176.69,168.16,174Z",
    fill: "#68e1fd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.a33ec5622908fbbb0dcfa75cb52bc1b4.svg";
export { ForwardRef as ReactComponent };